import { useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import HOC from '../HOC';
import Container from '../../common/Container';
import { iframeCall } from '../../helpers/iframeHelper';

import { useTimer } from '../../hooks/useTimer';
import { trackEvent } from '../../helpers/common';
import events from '../../app/events';

const Title = styled.h3`
  margin-bottom: 10px;
`;

const Image = styled.div`
  background-image: url('${({ src }) => src}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 300px;
  margin: 0 auto 20px;
`;

const Body = styled.p`
  margin-bottom: 30px;

  h1 { font-size: 25px; margin: 35px 0 20px; };
  h2 { font-size: 22px; margin: 32px 0 19px; };
  h3 { font-size: 19px; margin: 30px 0 18px; };
  h4 { font-size: 17px; margin: 28px 0 17px; };
  a { text-decoration: none; color: ${process.env.REACT_APP_COLOR_RC_ACTIONS} };
  p { margin-bottom: 22px; }
  ul { padding-left: 20px; margin-bottom: 15px; }
  li { list-style: circle; margin-bottom: 15px; }
`;

const BlogArticle = ({
  discoveryData,
  setHeaderState
}) => {
  const { id } = useParams();
  const windowRef = useRef(window);
  const { title, image, body } = discoveryData.blogPosts[id];
  useEffect(() => {
    windowRef.current.scrollTo(0, 0);
    trackEvent(
      'DZ_BLOG_LAND',
      { blog_id: id }
    );
    setHeaderState({ blog_id: id });
  }, [id]);

  /**
   * Timer tracker for each activity
   */
  useTimer([], ({ duration }) => trackEvent(
    events.DZ_BLOG_PAGE_TIME_SPENT,
    { time_spent: duration, blog_id: id }
  ));

  return (
    <div>
      <Container>
        <Image src={image} alt="blog image" />
        <Title>{title}</Title>
        <Body
          onClick={(e) => {
            e.preventDefault();
            const isLink = e.target.tagName.toLowerCase() === 'a';
            if (isLink) {
              trackEvent('DZ_BLOG_LINK_TAP', {
                blog_id: id,
                url: e.target.href
              });
              iframeCall(`openLink?link=${e.target.href}`);
            }
          }}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </Container>
    </div>
  );
};

export default HOC(BlogArticle);
